import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { BranchProvider } from "../contexts/BranchContext";
import { DialogProvider } from "../contexts/DialogContext";
import { FormProvider } from "../contexts/BranchFormContext";
import { TenantProvider } from "../contexts/TenantContext";
export const BranchComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[
        <BranchProvider key={0} />,
        <FormProvider key={1} />,
        <DialogProvider key={2} />,
        <TenantProvider key={3} />,
      ]}
    >
      {children}
    </ContextProviderComposer>
  );
};
